import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { VideoFormData } from '../../types/videoPageTypings';
import { videoPayloadFunnelsPageFactory } from '../../utils/videoFunnelsPageFactory';

interface UpdateVideoFunnelPageRequest {
  id: string;
  payload: VideoFormData;
}

export function useTryToRequestUpdateVideoPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async ({ id, payload }: UpdateVideoFunnelPageRequest) => {
      const factory = await videoPayloadFunnelsPageFactory(payload);

      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        factory
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Vídeo',
        'Ocorreu um erro ao editar o funil de Vídeo, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestUpdateVideoPage: mutateAsync,
    isLoadingVideoUpdate: isLoading,
  };
}
